import * as React from 'react';

import {ClipPath, Defs, G, Mask, Path} from 'react-native-svg';

import {Icon} from '.';
import {IconProps} from './type';

const ChatIcon: React.FC<IconProps> = props => {
  return (
    <Icon {...props} fill={'none'}>
      <G clipPath="url(#a)">
        <Mask
          id="b"
          width={24}
          height={24}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}>
          <Path fill="#fff" d="M24 0H0v24h24V0Z" />
        </Mask>
        <G mask="url(#b)">
          <Mask
            id="c"
            width={24}
            height={24}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'luminance',
            }}>
            <Path fill="#fff" d="M0 0h23.998v23.998H0V0Z" />
          </Mask>
          <G fillRule="evenodd" clipRule="evenodd" mask="url(#c)">
            <Path
              fill="#100E3A"
              d="M23.997 14.998c0-2.333-1.152-4.446-3-5.947-.042 5.347-5.07 9.696-11.248 9.696H5.57c1.617 2.668 4.903 4.5 8.68 4.5h8.998a.752.752 0 0 0 .695-.464.74.74 0 0 0-.165-.815l-1.866-1.866c1.35-1.447 2.085-3.238 2.085-5.104Z"
            />
            <Path
              fill="#FFE475"
              d="M.002 9c0 1.865.735 3.651 2.085 5.104L.22 15.969a.744.744 0 0 0-.164.815c.118.282.39.464.694.464H9.75c5.377 0 9.75-3.697 9.75-8.248 0-4.551-4.373-8.249-9.75-8.249C4.374.751.002 4.45.002 9Z"
            />
            <Path
              fill="#100E3A"
              d="M14.249 6.75H5.251a.753.753 0 0 0-.751.75c0 .412.338.75.751.75h8.998c.413 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75Zm-3 3H5.252a.753.753 0 0 0-.751.749c0 .412.338.75.751.75h5.999c.412 0 .75-.338.75-.75a.752.752 0 0 0-.75-.75Z"
            />
          </G>
        </G>
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" d="M0 0h24v24H0z" />
        </ClipPath>
      </Defs>
    </Icon>
  );
};

export default ChatIcon;
